import Image from "next/image";
import Markdown from "markdown-to-jsx";
import { Check } from "lucide-react";

import { Paragraph } from "../ui/typography";

import { cn } from "@/lib/utils";

function FacultyCard({ name, speciality, facultyImage, items }) {
  return (
    <div className="group bg-primary-foreground p-3 border border-grayscale-input rounded-xl">
      <div className="relative flex gap-x-3 md:gap-x-0">
        <div className="relative h-35 md:h-auto flex-[1_0_100px] flex items-end bg-gradient-faculty p-3 rounded-lg md:aspect-16/10">
          <Image
            src={facultyImage}
            alt={name}
            className="w-auto! h-10/12! top-auto! left-1/2! -translate-x-1/2!"
            fill
          />

          <div
            className={cn(
              "hidden md:flex w-full items-center gap-x-2 p-3 rounded-lg backdrop-blur-xs",
              "bg-primary-foreground/91"
            )}
          >
            <Paragraph variant="b3-tight" weight="sb">
              {name}
            </Paragraph>
            <Paragraph variant="b5-tight" className="text-grayscale-label">
              {speciality}
            </Paragraph>
          </div>
        </div>

        <div
          className={cn(
            "bg-transparent md:bg-gradient-faculty md:invisible md:opacity-0 md:absolute top-0 left-0 size-full md:py-6 md:px-3",
            "rounded-lg space-y-3 duration-300 group-hover:visible group-hover:opacity-100"
          )}
        >
          <div
            className={cn(
              "flex justify-center md:hidden w-full items-center gap-x-2 py-1 px-2 rounded",
              "bg-gradient-faculty-title"
            )}
          >
            <Paragraph variant="b3-tight" weight="sb">
              {name}
            </Paragraph>
            <Paragraph variant="b5-tight" className="text-grayscale-label">
              {speciality}
            </Paragraph>
          </div>

          <ul className="flex flex-col gap-y-3.5 text-grayscale-body">
            {items.map((item) => (
              <li
                key={`${name}-${speciality}-${item}`}
                className="flex items-start gap-x-2"
              >
                <Check className="size-3 shrink-0" />
                <Markdown
                  variant="b5-tight"
                  as="span"
                  options={{ wrapper: Paragraph }}
                >
                  {item}
                </Markdown>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default FacultyCard;
